var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recaptcha-wrapper"},[_c('div',{ref:"recaptcha",staticClass:"custom-recaptcha"})])
}
var staticRenderFns = []

export { render, staticRenderFns }